import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const getPendingOrdersEmailSettings = httpsCallable(functions, "getPendingOrdersEmailSettings");
export const updatePendingOrdersEmailSettings = httpsCallable(functions, "updatePendingOrdersEmailSettings");
export const sendPendingOrdersTestEmail = httpsCallable(functions, "sendPendingOrdersTestEmail");
export const sendPendingOrderPartyAttachmentEmail = httpsCallable(functions, "sendPendingOrderPartyAttachmentEmail");
export const listPendingOrdersEmailLog = httpsCallable(functions, "listPendingOrdersEmailLog");
